<div>
    <h2 class="title m-2"> Asset <em class="ti-close pull-right" style="color: red; cursor: pointer;" (click)="onClose()"></em> </h2>
    <cradua-incidentassetpopup-search
      [task]="task"
      (searchEmit)="onSearch($event)"
      (emitTask)="onTask($event)"
    >
    </cradua-incidentassetpopup-search>
    
    <ng-container [ngSwitch]="task">
      <ng-template >
        <cradua-incidentassetpopup-list
          [landTitles]="searchedLandTitle"
          (emitLandTitle)="onViewTask($event)"
          (taskEmit)="onTask($event)"
        
          >
    <!-- ngSwitchCase="create" -->
      </cradua-incidentassetpopup-list>
      </ng-template>
      <ng-template ngSwitchCase="list">
    <div class="title pull-right">
      <button class="default_secondary-btn relatives" style="justify-content: right;" (click)="onSubmit()">Add</button>
    </div>
    <table class="table table-hover scroll">
      <thead>
        <tr>
          <th scope="col">S/N</th>
          <th scope="col">Asset Name</th>
          <th scope="col">State</th>
          <th scope="col">Lga</th>
          <th scope="col">Community</th>
          <th scope="col">Check</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let asset of assetFormArray.get('PipelineAssetLinks')['controls']; index as i"
        matTooltip="Click on check box to add"
          aria-label="Button that displays a tooltip when focused or hovered over">
          <th scope="row">{{i + 1}}</th>
          <td>
            <div class="the_input">
              <span class="content">{{asset.value.LandName}}</span>
          </div>
        </td>
          <td>
            <div class="the_input">
              <span class="content">{{getStateName(asset.value.StateId)}}</span>
            </div>
          </td>
          <td>
            <div class="the_input">
              <span class="content">{{getLgaName(asset.value.LgaId)}}</span>
            </div>
          </td>
          <td>
            <div class="the_input">
              <span class="content">{{getCommunityName(asset.value.CommunityId)}}</span>
            </div>
          </td>
          <td>
            <span class="content" (click)="$event.stopImmediatePropagation()" (click)="checkAsset(asset.value)" >
              <input type="checkbox" style="cursor: pointer;" (click)="checkAsset(asset.value)" [checked]="checkSelected(asset.value.LandName)">
            </span>
          </td>
        </tr>
    
      </tbody>
    </table>
    </ng-template>
    </ng-container>
    </div>
    
    <cradua-list-spinner
    *ngIf="isLoadingLandTitle === true"
    >
    </cradua-list-spinner>